// Third-Party Library
import ReactAsync from "react-select/async"

// Components
import { Label } from "reactstrap"
import { Input } from "components"

const Select = ({
  errors,
  id = Math.random().toString(36).substring(2, 7),
  label = "",
  onChange,
  options = [],
  placeholder = "Select...",
  loading,
  defaultValue,
  disabled = false,
  noMargin = false,
  ...rest
}) => {
  const filterColors = (inputValue) => {
    return options.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    )
  }

  const loadOptions = (inputValue, callback) => {
    setTimeout(() => {
      callback(filterColors(inputValue))
    }, 1000)
  }

  return (
    <div className={noMargin ? "mb-0" : "mb-3"}>
      <Label className='form-label fw-bold mb-0' for={`input-${id}`}>
        {label}
      </Label>

      {loading ? (
        <Input
          noLabel
          id={`input-${id}`}
          disabled
          value="Please wait..."
        />
      ) : (
        <ReactAsync
          {...rest}
          id={`input-${id}`}
          isClearable={false}
          styles={{ borderColor: 'red' }}
          classNamePrefix={errors ? "react-select-invalid" : "react-select"}
          placeholder={placeholder}
          loadOptions={loadOptions}
          defaultOptions
          onChange={onChange}
          defaultValue={defaultValue}
          isDisabled={disabled}
        />
      )}

      {errors && <small className="text-danger">{errors}</small>}
    </div>
  )
}

export { Select }